// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__E_Uzl","space":"footer_space__k_LTO"};